//@ts-nocheck

/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 6
 */
import type { AxiosRequestConfig } from 'axios';
//@ts-ignore
import qs from 'qs';
import type { SwaggerResponse } from './config';
import { Http } from './httpRequest';
import type {
  GetUsersQueryParams,
  GetRestaurantsQueryParams,
  GetOOrgSlugRestaurantsQueryParams,
  GetRestaurantsIdQueryParams,
  GetOOrgSlugRestaurantsIdQueryParams,
  GetRestaurantBranchesQueryParams,
  GetOOrgSlugRRestaurantIdRestaurantBranchesQueryParams,
  GetRestaurantBranchesIdQueryParams,
  GetOOrgSlugRRestaurantIdRestaurantBranchesIdQueryParams,
  GetRestaurantTablesIdQueryParams,
  GetOOrgSlugRRestaurantIdRestaurantTablesIdQueryParams,
  GetRestaurantTablesQueryParams,
  GetOOrgSlugRRestaurantIdRestaurantTablesQueryParams,
  GetPublicStorefrontsStorefrontSlugPostsQueryParams,
  GetStorefrontSlugAvailableQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontSlugAvailableQueryParams,
  GetStorefrontPostsIdQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontPostsIdQueryParams,
  GetStorefrontPostsQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontPostsQueryParams,
  GetStorefrontMessagesIdQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontMessagesIdQueryParams,
  GetStorefrontMessagesQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontMessagesQueryParams,
  GetMenuIdQueryParams,
  GetOOrgSlugRRestaurantIdMenuIdQueryParams,
  GetMenuQueryParams,
  GetOOrgSlugRRestaurantIdMenuQueryParams,
  GetMenuItemsQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemsQueryParams,
  GetMenuItemsIdQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemsIdQueryParams,
  GetMenuItemVariantsIdQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemVariantsIdQueryParams,
  GetMenuItemVariantsQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemVariantsQueryParams,
  GetEmployeesQueryParams,
  GetOOrgSlugRRestaurantIdEmployeesQueryParams,
  GetEmployeesIdQueryParams,
  GetOOrgSlugRRestaurantIdEmployeesIdQueryParams,
  GetDashboardSalesReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardSalesReportsQueryParams,
  GetDashboardAccountingReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReportsQueryParams,
  GetDashboardInventoryReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReportsQueryParams,
  GetDashboardStaffReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardStaffReportsQueryParams,
  GetDashboardIssueReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardIssueReportsQueryParams,
  GetDashboardEmployeeIncomesQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomesQueryParams,
  GetSchedulesMeQueryParams,
  GetOOrgSlugRRestaurantIdSchedulesMeQueryParams,
  GetSchedulesQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdSchedulesQueryParams,
  GetTimesheetsMeQueryParams,
  GetOOrgSlugRRestaurantIdTimesheetsMeQueryParams,
  GetTimesheetsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdTimesheetsQueryParams,
  GetTimesheetsCalendarQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendarQueryParams,
  GetOrdersQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersQueryParams,
  GetOrdersRecentQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersRecentQueryParams,
  GetOrdersDeliveryQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersDeliveryQueryParams,
  GetOrdersInProgressQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersInProgressQueryParams,
  GetTransactionsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdTransactionsQueryParams,
  GetTransactionsIdQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdTransactionsIdQueryParams,
  GetTransactionCategoriesIdQueryParams,
  GetOOrgSlugRRestaurantIdTransactionCategoriesIdQueryParams,
  GetTransactionCategoriesQueryParams,
  GetOOrgSlugRRestaurantIdTransactionCategoriesQueryParams,
  GetInventoryCategoriesIdQueryParams,
  GetOOrgSlugRRestaurantIdInventoryCategoriesIdQueryParams,
  GetInventoryCategoriesQueryParams,
  GetOOrgSlugRRestaurantIdInventoryCategoriesQueryParams,
  GetInventoryItemsQueryParams,
  GetOOrgSlugRRestaurantIdInventoryItemsQueryParams,
  GetInventoryItemsIdQueryParams,
  GetOOrgSlugRRestaurantIdInventoryItemsIdQueryParams,
  GetInventoryItemsStockLevelsQueryParams,
  GetOOrgSlugRRestaurantIdInventoryItemsStockLevelsQueryParams,
  GetInventoryMovementsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsQueryParams,
  GetInventoryMovementsIdQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsIdQueryParams,
  GetIssuesIdQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdIssuesIdQueryParams,
  GetIssuesQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdIssuesQueryParams,
  GetEmployeeRulesIdQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeRulesIdQueryParams,
  GetEmployeeRulesQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeRulesQueryParams,
  GetEmployeeDayOffIdQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeDayOffIdQueryParams,
  GetEmployeeDayOffQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeDayOffQueryParams,
  GetSearchQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdSearchQueryParams,
  GetZaloBranchesQueryParams,
  CreateUserDto,
  UpdateUserDto,
  AuthEmailLoginDto,
  UserEntity,
  GetManyEmployeeEntityResponseDto,
  EmployeeEntity,
  AuthEmailLoginResponse,
  RestaurantCreateDto,
  RestaurantUpdateDto,
  GetManyRestaurantEntityResponseDto,
  RestaurantEntity,
  RestaurantCurrencyDto,
  RestaurantBranchCreateDto,
  GetManyRestaurantBranchEntityResponseDto,
  RestaurantBranchEntity,
  RestaurantBranchUpdateDto,
  GetManyRestaurantTableEntityResponseDto,
  RestaurantTableEntity,
  RestaurantTableCreateDto,
  CreateManyRestaurantTableEntityDto,
  RestaurantTableUpdateDto,
  BillingStatusDto,
  BillingCheckoutDto,
  BillingRedirectDto,
  PublicStorefrontDto,
  PublicStorefrontPostPageDto,
  PublicStorefrontPostDto,
  PublicStorefrontContactDto,
  RestaurantStorefrontEntity,
  StorefrontUpdateDto,
  StorefrontBranchOrderingDto,
  StorefrontSlugAvailabilityDto,
  StorefrontPreviewLinkDto,
  GetManyStorefrontPostEntityResponseDto,
  StorefrontPostEntity,
  StorefrontPostCreateDto,
  StorefrontPostUpdateDto,
  GetManyStorefrontContactMessageEntityResponseDto,
  StorefrontContactMessageEntity,
  StorefrontMessageUpdateDto,
  OnboardingStatusDto,
  GetManyMenuEntityResponseDto,
  MenuEntity,
  MenuCreateDto,
  CreateManyMenuEntityDto,
  MenuUpdateDto,
  MenuItemCreateDto,
  GetManyMenuItemEntityResponseDto,
  MenuItemEntity,
  MenuItemUpdateDto,
  GetManyMenuItemVariantEntityResponseDto,
  MenuItemVariantEntity,
  MenuItemVariantCreateDto,
  CreateManyMenuItemVariantEntityDto,
  MenuItemVariantUpdateDto,
  CreateUploadUrlDto,
  UploadUrlResponse,
  EmployeeSelfProfileDto,
  EmployeeCreateDto,
  EmployeeUpdateDto,
  MyScheduleShiftDto,
  MyScheduleDto,
  ScheduleShiftDto,
  ScheduleListDto,
  PublishWeekDto,
  PublishResultDto,
  CopyWeekDto,
  CopyResultDto,
  CreateShiftDto,
  UpdateShiftDto,
  AssignShiftDto,
  ClockInDto,
  BreakStartDto,
  EmployeeNoteDto,
  KioskPunchDto,
  KioskConfirmDto,
  TimesheetHolidayEntity,
  LoadVnHolidaysDto,
  PinDto,
  TimesheetCalendarDto,
  ManualEntryDto,
  EntryPatchDto,
  ScheduleLinkDto,
  EntryScheduleDto,
  BreakDto,
  BreakPatchDto,
  ReopenDto,
  PayDto,
  OrderCreateDto,
  OrderEntity,
  OrderUpdateDto,
  OrderRejectionDto,
  TransactionCreateDto,
  TransactionUpdateDto,
  GetManyTransactionEntityResponseDto,
  TransactionEntity,
  CreateManyTransactionEntityDto,
  GetManyTransactionCategoryEntityResponseDto,
  TransactionCategoryEntity,
  TransactionCategoryCreateDto,
  CreateManyTransactionCategoryEntityDto,
  TransactionCategoryUpdateDto,
  GetManyInventoryCategoryEntityResponseDto,
  InventoryCategoryEntity,
  InventoryCategoryCreateDto,
  CreateManyInventoryCategoryEntityDto,
  InventoryCategoryUpdateDto,
  InventoryItemCreateDto,
  InventoryItemUpdateDto,
  GetManyInventoryItemEntityResponseDto,
  InventoryItemEntity,
  CreateManyInventoryItemEntityDto,
  InventoryMovementCreateDto,
  GetManyInventoryMovementEntityResponseDto,
  InventoryMovementEntity,
  IssuePositionDto,
  GetManyIssueEntityResponseDto,
  GetManyEmployeeRuleEntityResponseDto,
  EmployeeRuleEntity,
  IssueEntity,
  IssueCreateDto,
  CreateManyIssueEntityDto,
  IssueUpdateDto,
  CreateBankingNotificationDto,
  EmployeeRuleCreateDto,
  CreateManyEmployeeRuleEntityDto,
  EmployeeRuleUpdateDto,
  GetManyEmployeeDayOffEntityResponseDto,
  EmployeeDayOffEntity,
  EmployeeDayOffCreateDto,
  CreateManyEmployeeDayOffEntityDto,
  EmployeeDayOffUpdateDto,
  SearchResponseDto,
  PublicBranchDto,
  PublicMenuDto,
  PublicOrderCreateDto,
  PublicOrderStatusDto,
  MarketingContactDto,
  ZaloIntegrationReadDto,
  ZaloIntegrationWriteDto,
  ZaloSessionCreateDto,
  ZaloBranchListItemDto,
  ZaloBranchDto,
  ZaloOrderCreateDto,
  ZaloOrderStatusDto,
  ZaloTokenRedeemDto,
  ZaloPhoneDto,
  ZaloLocationDto,
} from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const __DEV__ = process.env.NODE_ENV !== 'production';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function overrideConfig(config?: AxiosRequestConfig, configOverride?: AxiosRequestConfig): AxiosRequestConfig {
  return {
    ...config,
    ...configOverride,
    headers: {
      ...config?.headers,
      ...configOverride?.headers,
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function template(path: string, obj: { [x: string]: any } = {}) {
  Object.keys(obj).forEach((key) => {
    const re = new RegExp(`{${key}}`, 'i');
    path = path.replace(re, obj[key]);
  });

  return path;
}

function isFormData(obj: any) {
  // This checks for the append method which should exist on FormData instances
  return (
    (typeof obj === 'object' && typeof obj.append === 'function' && obj[Symbol.toStringTag] === undefined) ||
    obj[Symbol.toStringTag] === 'FormData'
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function objToForm(requestBody: object) {
  if (isFormData(requestBody)) {
    return requestBody;
  }
  const formData = new FormData();

  Object.entries(requestBody).forEach(([key, value]) => {
    value && formData.append(key, value);
  });

  return formData;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function objToUrlencoded(requestBody: object) {
  return qs.stringify(requestBody);
}

/**
 *
 * Delete a single EmployeeDayOffEntity
 */
export const deleteEmployeeDayOffId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteEmployeeDayOffId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteEmployeeDayOffId.key = '/api/v1/employee-day-off/{id}';

/**
 *
 * Delete a single EmployeeRuleEntity
 */
export const deleteEmployeeRulesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteEmployeeRulesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteEmployeeRulesId.key = '/api/v1/employee-rules/{id}';

/**
 *
 * Delete a single EmployeeEntity
 */
export const deleteEmployeesId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteEmployeesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteEmployeesId.key = '/api/v1/employees/{id}';

export const deleteEmployeesIdInvited = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.deleteRequest(
    template(deleteEmployeesIdInvited.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteEmployeesIdInvited.key = '/api/v1/employees/{id}/invited';

export const deleteEmployeesIdTimesheetPin = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteEmployeesIdTimesheetPin.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteEmployeesIdTimesheetPin.key = '/api/v1/employees/{id}/timesheet-pin';

/**
 *
 * Delete a single InventoryCategoryEntity
 */
export const deleteInventoryCategoriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteInventoryCategoriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteInventoryCategoriesId.key = '/api/v1/inventory-categories/{id}';

/**
 *
 * Delete a single InventoryItemEntity
 */
export const deleteInventoryItemsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteInventoryItemsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteInventoryItemsId.key = '/api/v1/inventory-items/{id}';

/**
 *
 * Delete a single IssueEntity
 */
export const deleteIssuesId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteIssuesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteIssuesId.key = '/api/v1/issues/{id}';

/**
 *
 * Delete a single MenuEntity
 */
export const deleteMenuId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteMenuId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteMenuId.key = '/api/v1/menu/{id}';

/**
 *
 * Delete a single MenuItemVariantEntity
 */
export const deleteMenuItemVariantsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteMenuItemVariantsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteMenuItemVariantsId.key = '/api/v1/menu-item-variants/{id}';

/**
 *
 * Delete a single MenuItemEntity
 */
export const deleteMenuItemsId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteMenuItemsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteMenuItemsId.key = '/api/v1/menu-items/{id}';

/**
 *
 * Delete a single IssueEntity
 */
export const deleteOOrgSlugRRestaurantIdBBranchIdIssuesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdIssuesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdIssuesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}';

export const deleteOOrgSlugRRestaurantIdBBranchIdSchedulesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdSchedulesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdSchedulesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/{id}';

export const deleteOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssignEmployeeId = (
  id: string,
  employeeId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssignEmployeeId.key, { id, employeeId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssignEmployeeId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/{id}/assign/{employeeId}';

export const deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/breaks/{id}';

export const deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/entries/{id}';

/**
 *
 * Delete a single TransactionEntity
 */
export const deleteOOrgSlugRRestaurantIdBBranchIdTransactionsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdBBranchIdTransactionsId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/{id}';

/**
 *
 * Delete a single EmployeeDayOffEntity
 */
export const deleteOOrgSlugRRestaurantIdEmployeeDayOffId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdEmployeeDayOffId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdEmployeeDayOffId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/{id}';

/**
 *
 * Delete a single EmployeeRuleEntity
 */
export const deleteOOrgSlugRRestaurantIdEmployeeRulesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdEmployeeRulesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdEmployeeRulesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/{id}';

/**
 *
 * Delete a single EmployeeEntity
 */
export const deleteOOrgSlugRRestaurantIdEmployeesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdEmployeesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdEmployeesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}';

export const deleteOOrgSlugRRestaurantIdEmployeesIdInvited = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdEmployeesIdInvited.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdEmployeesIdInvited.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}/invited';

export const deleteOOrgSlugRRestaurantIdEmployeesIdTimesheetPin = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}/timesheet-pin';

/**
 *
 * Delete a single InventoryCategoryEntity
 */
export const deleteOOrgSlugRRestaurantIdInventoryCategoriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdInventoryCategoriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdInventoryCategoriesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/{id}';

/**
 *
 * Delete a single InventoryItemEntity
 */
export const deleteOOrgSlugRRestaurantIdInventoryItemsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdInventoryItemsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdInventoryItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/{id}';

/**
 *
 * Delete a single MenuEntity
 */
export const deleteOOrgSlugRRestaurantIdMenuId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdMenuId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdMenuId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/{id}';

/**
 *
 * Delete a single MenuItemVariantEntity
 */
export const deleteOOrgSlugRRestaurantIdMenuItemVariantsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdMenuItemVariantsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdMenuItemVariantsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/{id}';

/**
 *
 * Delete a single MenuItemEntity
 */
export const deleteOOrgSlugRRestaurantIdMenuItemsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdMenuItemsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdMenuItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items/{id}';

/**
 *
 * Delete a single RestaurantBranchEntity
 */
export const deleteOOrgSlugRRestaurantIdRestaurantBranchesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdRestaurantBranchesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdRestaurantBranchesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches/{id}';

/**
 *
 * Delete a single RestaurantTableEntity
 */
export const deleteOOrgSlugRRestaurantIdRestaurantTablesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdRestaurantTablesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdRestaurantTablesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables/{id}';

export const deleteOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister = (
  shiftId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key, { shiftId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/schedules/me/{shiftId}/register';

/**
 *
 * Delete a single StorefrontPostEntity
 */
export const deleteOOrgSlugRRestaurantIdStorefrontPostsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdStorefrontPostsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdStorefrontPostsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/posts/{id}';

export const deleteOOrgSlugRRestaurantIdTimesheetsHolidaysId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdTimesheetsHolidaysId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdTimesheetsHolidaysId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/holidays/{id}';

/**
 *
 * Delete a single TransactionCategoryEntity
 */
export const deleteOOrgSlugRRestaurantIdTransactionCategoriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRRestaurantIdTransactionCategoriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRRestaurantIdTransactionCategoriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/{id}';

/**
 *
 * Delete a single RestaurantEntity
 */
export const deleteOOrgSlugRestaurantsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteOOrgSlugRestaurantsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteOOrgSlugRestaurantsId.key = '/api/v1/o/{orgSlug}/restaurants/{id}';

/**
 *
 * Delete a single RestaurantBranchEntity
 */
export const deleteRestaurantBranchesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteRestaurantBranchesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteRestaurantBranchesId.key = '/api/v1/restaurant-branches/{id}';

/**
 *
 * Delete a single RestaurantTableEntity
 */
export const deleteRestaurantTablesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteRestaurantTablesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteRestaurantTablesId.key = '/api/v1/restaurant-tables/{id}';

/**
 *
 * Delete a single RestaurantEntity
 */
export const deleteRestaurantsId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteRestaurantsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteRestaurantsId.key = '/api/v1/restaurants/{id}';

export const deleteSchedulesId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteSchedulesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteSchedulesId.key = '/api/v1/schedules/{id}';

export const deleteSchedulesIdAssignEmployeeId = (
  id: string,
  employeeId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteSchedulesIdAssignEmployeeId.key, { id, employeeId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteSchedulesIdAssignEmployeeId.key = '/api/v1/schedules/{id}/assign/{employeeId}';

export const deleteSchedulesMeShiftIdRegister = (
  shiftId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteSchedulesMeShiftIdRegister.key, { shiftId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteSchedulesMeShiftIdRegister.key = '/api/v1/schedules/me/{shiftId}/register';

/**
 *
 * Delete a single StorefrontPostEntity
 */
export const deleteStorefrontPostsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteStorefrontPostsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteStorefrontPostsId.key = '/api/v1/storefront/posts/{id}';

export const deleteTimesheetsBreaksId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteTimesheetsBreaksId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteTimesheetsBreaksId.key = '/api/v1/timesheets/breaks/{id}';

export const deleteTimesheetsEntriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteTimesheetsEntriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteTimesheetsEntriesId.key = '/api/v1/timesheets/entries/{id}';

export const deleteTimesheetsHolidaysId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteTimesheetsHolidaysId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteTimesheetsHolidaysId.key = '/api/v1/timesheets/holidays/{id}';

/**
 *
 * Delete a single TransactionCategoryEntity
 */
export const deleteTransactionCategoriesId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteTransactionCategoriesId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteTransactionCategoriesId.key = '/api/v1/transaction-categories/{id}';

/**
 *
 * Delete a single TransactionEntity
 */
export const deleteTransactionsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteTransactionsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteTransactionsId.key = '/api/v1/transactions/{id}';

export const deleteUsersId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.deleteRequest(
    template(deleteUsersId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
deleteUsersId.key = '/api/v1/users/{id}';

export const get = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(get.key, undefined, undefined, undefined, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
get.key = '/';

export const getAuthMe = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<UserEntity>> => {
  return Http.getRequest(getAuthMe.key, undefined, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getAuthMe.key = '/api/v1/auth/me';

export const getDashboardAccountingReports = (
  queryParams: GetDashboardAccountingReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardAccountingReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardAccountingReports.key = '/api/v1/dashboard/accounting-reports';

export const getDashboardEmployeeIncomes = (
  queryParams: GetDashboardEmployeeIncomesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardEmployeeIncomes.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardEmployeeIncomes.key = '/api/v1/dashboard/employee-incomes';

export const getDashboardInventoryReports = (
  queryParams: GetDashboardInventoryReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardInventoryReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardInventoryReports.key = '/api/v1/dashboard/inventory-reports';

export const getDashboardIssueReports = (
  queryParams: GetDashboardIssueReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardIssueReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardIssueReports.key = '/api/v1/dashboard/issue-reports';

export const getDashboardSalesReports = (
  queryParams: GetDashboardSalesReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardSalesReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardSalesReports.key = '/api/v1/dashboard/sales-reports';

export const getDashboardStaffReports = (
  queryParams: GetDashboardStaffReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getDashboardStaffReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getDashboardStaffReports.key = '/api/v1/dashboard/staff-reports';

/**
 *
 * Retrieve multiple EmployeeDayOffEntities
 */
export const getEmployeeDayOff = (
  queryParams?: GetEmployeeDayOffQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeDayOffEntityResponseDto>> => {
  return Http.getRequest(
    getEmployeeDayOff.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeeDayOff.key = '/api/v1/employee-day-off';

/**
 *
 * Retrieve a single EmployeeDayOffEntity
 */
export const getEmployeeDayOffId = (
  id: string,
  queryParams?: GetEmployeeDayOffIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.getRequest(
    template(getEmployeeDayOffId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeeDayOffId.key = '/api/v1/employee-day-off/{id}';

/**
 *
 * Retrieve multiple EmployeeRuleEntities
 */
export const getEmployeeRules = (
  queryParams?: GetEmployeeRulesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeRuleEntityResponseDto>> => {
  return Http.getRequest(
    getEmployeeRules.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeeRules.key = '/api/v1/employee-rules';

/**
 *
 * Retrieve a single EmployeeRuleEntity
 */
export const getEmployeeRulesId = (
  id: string,
  queryParams?: GetEmployeeRulesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.getRequest(
    template(getEmployeeRulesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeeRulesId.key = '/api/v1/employee-rules/{id}';

/**
 *
 * Retrieve multiple EmployeeEntities
 */
export const getEmployees = (
  queryParams?: GetEmployeesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeEntityResponseDto>> => {
  return Http.getRequest(
    getEmployees.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployees.key = '/api/v1/employees';

/**
 *
 * Retrieve a single EmployeeEntity
 */
export const getEmployeesId = (
  id: string,
  queryParams?: GetEmployeesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.getRequest(
    template(getEmployeesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeesId.key = '/api/v1/employees/{id}';

export const getEmployeesMe = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.getRequest(
    getEmployeesMe.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeesMe.key = '/api/v1/employees/me';

export const getEmployeesMeIncomes = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getEmployeesMeIncomes.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getEmployeesMeIncomes.key = '/api/v1/employees/me/incomes';

export const getIntegrationsZalo = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> => {
  return Http.getRequest(
    getIntegrationsZalo.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getIntegrationsZalo.key = '/api/v1/integrations/zalo';

export const getIntegrationsZaloExport = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getIntegrationsZaloExport.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getIntegrationsZaloExport.key = '/api/v1/integrations/zalo/export';

/**
 *
 * Retrieve multiple InventoryCategoryEntities
 */
export const getInventoryCategories = (
  queryParams?: GetInventoryCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryCategoryEntityResponseDto>> => {
  return Http.getRequest(
    getInventoryCategories.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryCategories.key = '/api/v1/inventory-categories';

/**
 *
 * Retrieve a single InventoryCategoryEntity
 */
export const getInventoryCategoriesId = (
  id: string,
  queryParams?: GetInventoryCategoriesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.getRequest(
    template(getInventoryCategoriesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryCategoriesId.key = '/api/v1/inventory-categories/{id}';

/**
 *
 * Retrieve multiple InventoryItemEntities
 */
export const getInventoryItems = (
  queryParams?: GetInventoryItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryItemEntityResponseDto>> => {
  return Http.getRequest(
    getInventoryItems.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryItems.key = '/api/v1/inventory-items';

/**
 *
 * Retrieve a single InventoryItemEntity
 */
export const getInventoryItemsId = (
  id: string,
  queryParams?: GetInventoryItemsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.getRequest(
    template(getInventoryItemsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryItemsId.key = '/api/v1/inventory-items/{id}';

export const getInventoryItemsStockLevels = (
  queryParams?: GetInventoryItemsStockLevelsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getInventoryItemsStockLevels.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryItemsStockLevels.key = '/api/v1/inventory-items/stock-levels';

/**
 *
 * Retrieve multiple InventoryMovementEntities
 */
export const getInventoryMovements = (
  queryParams?: GetInventoryMovementsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryMovementEntityResponseDto>> => {
  return Http.getRequest(
    getInventoryMovements.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryMovements.key = '/api/v1/inventory-movements';

/**
 *
 * Retrieve a single InventoryMovementEntity
 */
export const getInventoryMovementsId = (
  id: string,
  queryParams?: GetInventoryMovementsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryMovementEntity>> => {
  return Http.getRequest(
    template(getInventoryMovementsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getInventoryMovementsId.key = '/api/v1/inventory-movements/{id}';

/**
 *
 * Retrieve multiple IssueEntities
 */
export const getIssues = (
  queryParams?: GetIssuesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyIssueEntityResponseDto>> => {
  return Http.getRequest(getIssues.key, queryParams, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getIssues.key = '/api/v1/issues';

/**
 *
 * Retrieve a single IssueEntity
 */
export const getIssuesId = (
  id: string,
  queryParams?: GetIssuesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.getRequest(
    template(getIssuesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getIssuesId.key = '/api/v1/issues/{id}';

/**
 *
 * Retrieve multiple MenuEntities
 */
export const getMenu = (
  queryParams?: GetMenuQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuEntityResponseDto>> => {
  return Http.getRequest(getMenu.key, queryParams, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getMenu.key = '/api/v1/menu';

/**
 *
 * Retrieve a single MenuEntity
 */
export const getMenuId = (
  id: string,
  queryParams?: GetMenuIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.getRequest(
    template(getMenuId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getMenuId.key = '/api/v1/menu/{id}';

/**
 *
 * Retrieve multiple MenuItemVariantEntities
 */
export const getMenuItemVariants = (
  queryParams?: GetMenuItemVariantsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemVariantEntityResponseDto>> => {
  return Http.getRequest(
    getMenuItemVariants.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getMenuItemVariants.key = '/api/v1/menu-item-variants';

/**
 *
 * Retrieve a single MenuItemVariantEntity
 */
export const getMenuItemVariantsId = (
  id: string,
  queryParams?: GetMenuItemVariantsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.getRequest(
    template(getMenuItemVariantsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getMenuItemVariantsId.key = '/api/v1/menu-item-variants/{id}';

/**
 *
 * Retrieve multiple MenuItemEntities
 */
export const getMenuItems = (
  queryParams?: GetMenuItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemEntityResponseDto>> => {
  return Http.getRequest(
    getMenuItems.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getMenuItems.key = '/api/v1/menu-items';

/**
 *
 * Retrieve a single MenuItemEntity
 */
export const getMenuItemsId = (
  id: string,
  queryParams?: GetMenuItemsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.getRequest(
    template(getMenuItemsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getMenuItemsId.key = '/api/v1/menu-items/{id}';

export const getOOrgSlugBilling = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<BillingStatusDto>> => {
  return Http.getRequest(
    getOOrgSlugBilling.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugBilling.key = '/api/v1/o/{orgSlug}/billing';

export const getOOrgSlugIntegrationsZalo = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> => {
  return Http.getRequest(
    getOOrgSlugIntegrationsZalo.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugIntegrationsZalo.key = '/api/v1/o/{orgSlug}/integrations/zalo';

export const getOOrgSlugIntegrationsZaloExport = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugIntegrationsZaloExport.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugIntegrationsZaloExport.key = '/api/v1/o/{orgSlug}/integrations/zalo/export';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReports = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReports.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/accounting-reports';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomes = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomes.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomes.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/employee-incomes';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReports = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReports.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/inventory-reports';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardIssueReports = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardIssueReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardIssueReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardIssueReports.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/issue-reports';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardSalesReports = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardSalesReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardSalesReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardSalesReports.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/sales-reports';

export const getOOrgSlugRRestaurantIdBBranchIdDashboardStaffReports = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardStaffReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdDashboardStaffReports.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdDashboardStaffReports.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/dashboard/staff-reports';

/**
 *
 * Retrieve multiple InventoryMovementEntities
 */
export const getOOrgSlugRRestaurantIdBBranchIdInventoryMovements = (
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryMovementEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/inventory-movements';

/**
 *
 * Retrieve a single InventoryMovementEntity
 */
export const getOOrgSlugRRestaurantIdBBranchIdInventoryMovementsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryMovementEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdBBranchIdInventoryMovementsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdInventoryMovementsId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/inventory-movements/{id}';

/**
 *
 * Retrieve multiple IssueEntities
 */
export const getOOrgSlugRRestaurantIdBBranchIdIssues = (
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdIssuesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyIssueEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdIssues.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdIssues.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues';

/**
 *
 * Retrieve a single IssueEntity
 */
export const getOOrgSlugRRestaurantIdBBranchIdIssuesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdIssuesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdBBranchIdIssuesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdIssuesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}';

export const getOOrgSlugRRestaurantIdBBranchIdOrders = (
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdOrdersQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdOrders.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrders.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders';

export const getOOrgSlugRRestaurantIdBBranchIdOrdersDelivery = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersDeliveryQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdOrdersDelivery.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrdersDelivery.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/delivery';

export const getOOrgSlugRRestaurantIdBBranchIdOrdersId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdBBranchIdOrdersId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrdersId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/{id}';

export const getOOrgSlugRRestaurantIdBBranchIdOrdersInProgress = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersInProgressQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdOrdersInProgress.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrdersInProgress.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/in-progress';

export const getOOrgSlugRRestaurantIdBBranchIdOrdersPaidOrderTokens = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<string[]>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdOrdersPaidOrderTokens.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrdersPaidOrderTokens.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/paid-order-tokens';

export const getOOrgSlugRRestaurantIdBBranchIdOrdersRecent = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersRecentQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdOrdersRecent.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdOrdersRecent.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/recent';

export const getOOrgSlugRRestaurantIdBBranchIdSchedules = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdSchedulesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleListDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdSchedules.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdSchedules.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules';

export const getOOrgSlugRRestaurantIdBBranchIdSearch = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdSearchQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<SearchResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdSearch.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdSearch.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/search';

export const getOOrgSlugRRestaurantIdBBranchIdTimesheets = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdTimesheetsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdTimesheets.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTimesheets.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets';

export const getOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendar = (
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendarQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TimesheetCalendarDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendar.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendar.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/calendar';

export const getOOrgSlugRRestaurantIdBBranchIdTimesheetsId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdBBranchIdTimesheetsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTimesheetsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/{id}';

export const getOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskRoster = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskRoster.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskRoster.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/kiosk/roster';

/**
 *
 * Retrieve multiple TransactionEntities
 */
export const getOOrgSlugRRestaurantIdBBranchIdTransactions = (
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdTransactionsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdBBranchIdTransactions.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTransactions.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions';

/**
 *
 * Retrieve a single TransactionEntity
 */
export const getOOrgSlugRRestaurantIdBBranchIdTransactionsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdTransactionsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdBBranchIdTransactionsId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/{id}';

/**
 *
 * Retrieve multiple EmployeeDayOffEntities
 */
export const getOOrgSlugRRestaurantIdEmployeeDayOff = (
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeDayOffQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeDayOffEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdEmployeeDayOff.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeeDayOff.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off';

/**
 *
 * Retrieve a single EmployeeDayOffEntity
 */
export const getOOrgSlugRRestaurantIdEmployeeDayOffId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeDayOffIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdEmployeeDayOffId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeeDayOffId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/{id}';

/**
 *
 * Retrieve multiple EmployeeRuleEntities
 */
export const getOOrgSlugRRestaurantIdEmployeeRules = (
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeRulesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeRuleEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdEmployeeRules.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeeRules.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules';

/**
 *
 * Retrieve a single EmployeeRuleEntity
 */
export const getOOrgSlugRRestaurantIdEmployeeRulesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeRulesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdEmployeeRulesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeeRulesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/{id}';

/**
 *
 * Retrieve multiple EmployeeEntities
 */
export const getOOrgSlugRRestaurantIdEmployees = (
  queryParams?: GetOOrgSlugRRestaurantIdEmployeesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdEmployees.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployees.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees';

/**
 *
 * Retrieve a single EmployeeEntity
 */
export const getOOrgSlugRRestaurantIdEmployeesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdEmployeesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}';

export const getOOrgSlugRRestaurantIdEmployeesMe = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdEmployeesMe.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeesMe.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/me';

export const getOOrgSlugRRestaurantIdEmployeesMeIncomes = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdEmployeesMeIncomes.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdEmployeesMeIncomes.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/me/incomes';

/**
 *
 * Retrieve multiple InventoryCategoryEntities
 */
export const getOOrgSlugRRestaurantIdInventoryCategories = (
  queryParams?: GetOOrgSlugRRestaurantIdInventoryCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryCategoryEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdInventoryCategories.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdInventoryCategories.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories';

/**
 *
 * Retrieve a single InventoryCategoryEntity
 */
export const getOOrgSlugRRestaurantIdInventoryCategoriesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdInventoryCategoriesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdInventoryCategoriesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdInventoryCategoriesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/{id}';

/**
 *
 * Retrieve multiple InventoryItemEntities
 */
export const getOOrgSlugRRestaurantIdInventoryItems = (
  queryParams?: GetOOrgSlugRRestaurantIdInventoryItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryItemEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdInventoryItems.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdInventoryItems.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items';

/**
 *
 * Retrieve a single InventoryItemEntity
 */
export const getOOrgSlugRRestaurantIdInventoryItemsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdInventoryItemsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdInventoryItemsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdInventoryItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/{id}';

export const getOOrgSlugRRestaurantIdInventoryItemsStockLevels = (
  queryParams?: GetOOrgSlugRRestaurantIdInventoryItemsStockLevelsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdInventoryItemsStockLevels.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdInventoryItemsStockLevels.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/stock-levels';

/**
 *
 * Retrieve multiple MenuEntities
 */
export const getOOrgSlugRRestaurantIdMenu = (
  queryParams?: GetOOrgSlugRRestaurantIdMenuQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdMenu.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenu.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu';

/**
 *
 * Retrieve a single MenuEntity
 */
export const getOOrgSlugRRestaurantIdMenuId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdMenuIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdMenuId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenuId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/{id}';

/**
 *
 * Retrieve multiple MenuItemVariantEntities
 */
export const getOOrgSlugRRestaurantIdMenuItemVariants = (
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemVariantsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemVariantEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdMenuItemVariants.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenuItemVariants.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants';

/**
 *
 * Retrieve a single MenuItemVariantEntity
 */
export const getOOrgSlugRRestaurantIdMenuItemVariantsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemVariantsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdMenuItemVariantsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenuItemVariantsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/{id}';

/**
 *
 * Retrieve multiple MenuItemEntities
 */
export const getOOrgSlugRRestaurantIdMenuItems = (
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdMenuItems.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenuItems.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items';

/**
 *
 * Retrieve a single MenuItemEntity
 */
export const getOOrgSlugRRestaurantIdMenuItemsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdMenuItemsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdMenuItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items/{id}';

/**
 *
 * Retrieve multiple RestaurantBranchEntities
 */
export const getOOrgSlugRRestaurantIdRestaurantBranches = (
  queryParams?: GetOOrgSlugRRestaurantIdRestaurantBranchesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantBranchEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdRestaurantBranches.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdRestaurantBranches.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches';

/**
 *
 * Retrieve a single RestaurantBranchEntity
 */
export const getOOrgSlugRRestaurantIdRestaurantBranchesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdRestaurantBranchesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdRestaurantBranchesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdRestaurantBranchesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches/{id}';

export const getOOrgSlugRRestaurantIdRestaurantCurrency = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantCurrencyDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdRestaurantCurrency.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdRestaurantCurrency.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-currency';

/**
 *
 * Retrieve multiple RestaurantTableEntities
 */
export const getOOrgSlugRRestaurantIdRestaurantTables = (
  queryParams?: GetOOrgSlugRRestaurantIdRestaurantTablesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantTableEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdRestaurantTables.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdRestaurantTables.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables';

/**
 *
 * Retrieve a single RestaurantTableEntity
 */
export const getOOrgSlugRRestaurantIdRestaurantTablesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdRestaurantTablesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdRestaurantTablesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdRestaurantTablesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables/{id}';

export const getOOrgSlugRRestaurantIdSchedulesMe = (
  queryParams: GetOOrgSlugRRestaurantIdSchedulesMeQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MyScheduleDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdSchedulesMe.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdSchedulesMe.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/schedules/me';

export const getOOrgSlugRRestaurantIdStorefront = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdStorefront.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefront.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront';

export const getOOrgSlugRRestaurantIdStorefrontBranches = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity[]>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdStorefrontBranches.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontBranches.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/branches';

/**
 *
 * Retrieve multiple StorefrontContactMessageEntities
 */
export const getOOrgSlugRRestaurantIdStorefrontMessages = (
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontMessagesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontContactMessageEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdStorefrontMessages.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontMessages.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/messages';

/**
 *
 * Retrieve a single StorefrontContactMessageEntity
 */
export const getOOrgSlugRRestaurantIdStorefrontMessagesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontMessagesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontContactMessageEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdStorefrontMessagesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontMessagesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/messages/{id}';

/**
 *
 * Retrieve multiple StorefrontPostEntities
 */
export const getOOrgSlugRRestaurantIdStorefrontPosts = (
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontPostsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontPostEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdStorefrontPosts.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontPosts.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/posts';

/**
 *
 * Retrieve a single StorefrontPostEntity
 */
export const getOOrgSlugRRestaurantIdStorefrontPostsId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontPostsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPostEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdStorefrontPostsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontPostsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/posts/{id}';

export const getOOrgSlugRRestaurantIdStorefrontSlugAvailable = (
  queryParams: GetOOrgSlugRRestaurantIdStorefrontSlugAvailableQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontSlugAvailabilityDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdStorefrontSlugAvailable.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdStorefrontSlugAvailable.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/slug-available';

export const getOOrgSlugRRestaurantIdTimesheetsHolidays = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdTimesheetsHolidays.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdTimesheetsHolidays.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/holidays';

export const getOOrgSlugRRestaurantIdTimesheetsMe = (
  queryParams: GetOOrgSlugRRestaurantIdTimesheetsMeQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdTimesheetsMe.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdTimesheetsMe.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me';

export const getOOrgSlugRRestaurantIdTimesheetsMeCurrent = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdTimesheetsMeCurrent.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdTimesheetsMeCurrent.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/current';

/**
 *
 * Retrieve multiple TransactionCategoryEntities
 */
export const getOOrgSlugRRestaurantIdTransactionCategories = (
  queryParams?: GetOOrgSlugRRestaurantIdTransactionCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionCategoryEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRRestaurantIdTransactionCategories.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdTransactionCategories.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories';

/**
 *
 * Retrieve a single TransactionCategoryEntity
 */
export const getOOrgSlugRRestaurantIdTransactionCategoriesId = (
  id: string,
  queryParams?: GetOOrgSlugRRestaurantIdTransactionCategoriesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRRestaurantIdTransactionCategoriesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRRestaurantIdTransactionCategoriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/{id}';

/**
 *
 * Retrieve multiple RestaurantEntities
 */
export const getOOrgSlugRestaurants = (
  queryParams?: GetOOrgSlugRestaurantsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantEntityResponseDto>> => {
  return Http.getRequest(
    getOOrgSlugRestaurants.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRestaurants.key = '/api/v1/o/{orgSlug}/restaurants';

/**
 *
 * Retrieve a single RestaurantEntity
 */
export const getOOrgSlugRestaurantsId = (
  id: string,
  queryParams?: GetOOrgSlugRestaurantsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.getRequest(
    template(getOOrgSlugRestaurantsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOOrgSlugRestaurantsId.key = '/api/v1/o/{orgSlug}/restaurants/{id}';

export const getOnboardingStatus = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<OnboardingStatusDto>> => {
  return Http.getRequest(
    getOnboardingStatus.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOnboardingStatus.key = '/api/v1/onboarding/status';

export const getOrders = (
  queryParams?: GetOrdersQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(getOrders.key, queryParams, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getOrders.key = '/api/v1/orders';

export const getOrdersDelivery = (
  queryParams: GetOrdersDeliveryQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOrdersDelivery.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOrdersDelivery.key = '/api/v1/orders/delivery';

export const getOrdersId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(getOrdersId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOrdersId.key = '/api/v1/orders/{id}';

export const getOrdersInProgress = (
  queryParams: GetOrdersInProgressQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOrdersInProgress.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOrdersInProgress.key = '/api/v1/orders/in-progress';

export const getOrdersPaidOrderTokens = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<string[]>> => {
  return Http.getRequest(
    getOrdersPaidOrderTokens.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOrdersPaidOrderTokens.key = '/api/v1/orders/paid-order-tokens';

export const getOrdersRecent = (
  queryParams: GetOrdersRecentQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> => {
  return Http.getRequest(
    getOrdersRecent.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getOrdersRecent.key = '/api/v1/orders/recent';

export const getPublicBBranchRef = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<PublicBranchDto>> => {
  return Http.getRequest(
    getPublicBBranchRef.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicBBranchRef.key = '/api/v1/public/b/{branchRef}';

export const getPublicBBranchRefMenu = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicMenuDto[]>> => {
  return Http.getRequest(
    getPublicBBranchRefMenu.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicBBranchRefMenu.key = '/api/v1/public/b/{branchRef}/menu';

export const getPublicOrdersPublicToken = (
  publicToken: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicOrderStatusDto>> => {
  return Http.getRequest(
    template(getPublicOrdersPublicToken.key, { publicToken }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicOrdersPublicToken.key = '/api/v1/public/orders/{publicToken}';

export const getPublicStorefrontsStorefrontSlug = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicStorefrontDto>> => {
  return Http.getRequest(
    getPublicStorefrontsStorefrontSlug.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicStorefrontsStorefrontSlug.key = '/api/v1/public/storefronts/{storefrontSlug}';

export const getPublicStorefrontsStorefrontSlugPosts = (
  queryParams: GetPublicStorefrontsStorefrontSlugPostsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicStorefrontPostPageDto>> => {
  return Http.getRequest(
    getPublicStorefrontsStorefrontSlugPosts.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicStorefrontsStorefrontSlugPosts.key = '/api/v1/public/storefronts/{storefrontSlug}/posts';

export const getPublicStorefrontsStorefrontSlugPostsPostSlug = (
  postSlug: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicStorefrontPostDto>> => {
  return Http.getRequest(
    template(getPublicStorefrontsStorefrontSlugPostsPostSlug.key, { postSlug }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getPublicStorefrontsStorefrontSlugPostsPostSlug.key = '/api/v1/public/storefronts/{storefrontSlug}/posts/{postSlug}';

/**
 *
 * Retrieve multiple RestaurantBranchEntities
 */
export const getRestaurantBranches = (
  queryParams?: GetRestaurantBranchesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantBranchEntityResponseDto>> => {
  return Http.getRequest(
    getRestaurantBranches.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantBranches.key = '/api/v1/restaurant-branches';

/**
 *
 * Retrieve a single RestaurantBranchEntity
 */
export const getRestaurantBranchesId = (
  id: string,
  queryParams?: GetRestaurantBranchesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.getRequest(
    template(getRestaurantBranchesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantBranchesId.key = '/api/v1/restaurant-branches/{id}';

export const getRestaurantCurrency = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantCurrencyDto>> => {
  return Http.getRequest(
    getRestaurantCurrency.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantCurrency.key = '/api/v1/restaurant-currency';

/**
 *
 * Retrieve multiple RestaurantTableEntities
 */
export const getRestaurantTables = (
  queryParams?: GetRestaurantTablesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantTableEntityResponseDto>> => {
  return Http.getRequest(
    getRestaurantTables.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantTables.key = '/api/v1/restaurant-tables';

/**
 *
 * Retrieve a single RestaurantTableEntity
 */
export const getRestaurantTablesId = (
  id: string,
  queryParams?: GetRestaurantTablesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.getRequest(
    template(getRestaurantTablesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantTablesId.key = '/api/v1/restaurant-tables/{id}';

/**
 *
 * Retrieve multiple RestaurantEntities
 */
export const getRestaurants = (
  queryParams?: GetRestaurantsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantEntityResponseDto>> => {
  return Http.getRequest(
    getRestaurants.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurants.key = '/api/v1/restaurants';

/**
 *
 * Retrieve a single RestaurantEntity
 */
export const getRestaurantsId = (
  id: string,
  queryParams?: GetRestaurantsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.getRequest(
    template(getRestaurantsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getRestaurantsId.key = '/api/v1/restaurants/{id}';

export const getSchedules = (
  queryParams: GetSchedulesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleListDto>> => {
  return Http.getRequest(
    getSchedules.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getSchedules.key = '/api/v1/schedules';

export const getSchedulesMe = (
  queryParams: GetSchedulesMeQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MyScheduleDto>> => {
  return Http.getRequest(
    getSchedulesMe.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getSchedulesMe.key = '/api/v1/schedules/me';

export const getSearch = (
  queryParams: GetSearchQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<SearchResponseDto>> => {
  return Http.getRequest(getSearch.key, queryParams, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getSearch.key = '/api/v1/search';

export const getStorefront = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.getRequest(
    getStorefront.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefront.key = '/api/v1/storefront';

export const getStorefrontBranches = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity[]>> => {
  return Http.getRequest(
    getStorefrontBranches.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontBranches.key = '/api/v1/storefront/branches';

/**
 *
 * Retrieve multiple StorefrontContactMessageEntities
 */
export const getStorefrontMessages = (
  queryParams?: GetStorefrontMessagesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontContactMessageEntityResponseDto>> => {
  return Http.getRequest(
    getStorefrontMessages.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontMessages.key = '/api/v1/storefront/messages';

/**
 *
 * Retrieve a single StorefrontContactMessageEntity
 */
export const getStorefrontMessagesId = (
  id: string,
  queryParams?: GetStorefrontMessagesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontContactMessageEntity>> => {
  return Http.getRequest(
    template(getStorefrontMessagesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontMessagesId.key = '/api/v1/storefront/messages/{id}';

/**
 *
 * Retrieve multiple StorefrontPostEntities
 */
export const getStorefrontPosts = (
  queryParams?: GetStorefrontPostsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontPostEntityResponseDto>> => {
  return Http.getRequest(
    getStorefrontPosts.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontPosts.key = '/api/v1/storefront/posts';

/**
 *
 * Retrieve a single StorefrontPostEntity
 */
export const getStorefrontPostsId = (
  id: string,
  queryParams?: GetStorefrontPostsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPostEntity>> => {
  return Http.getRequest(
    template(getStorefrontPostsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontPostsId.key = '/api/v1/storefront/posts/{id}';

export const getStorefrontSlugAvailable = (
  queryParams: GetStorefrontSlugAvailableQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontSlugAvailabilityDto>> => {
  return Http.getRequest(
    getStorefrontSlugAvailable.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getStorefrontSlugAvailable.key = '/api/v1/storefront/slug-available';

export const getTimesheets = (
  queryParams: GetTimesheetsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getTimesheets.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheets.key = '/api/v1/timesheets';

export const getTimesheetsCalendar = (
  queryParams: GetTimesheetsCalendarQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TimesheetCalendarDto>> => {
  return Http.getRequest(
    getTimesheetsCalendar.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsCalendar.key = '/api/v1/timesheets/calendar';

export const getTimesheetsHolidays = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getTimesheetsHolidays.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsHolidays.key = '/api/v1/timesheets/holidays';

export const getTimesheetsId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(getTimesheetsId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsId.key = '/api/v1/timesheets/{id}';

export const getTimesheetsKioskRoster = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getTimesheetsKioskRoster.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsKioskRoster.key = '/api/v1/timesheets/kiosk/roster';

export const getTimesheetsMe = (
  queryParams: GetTimesheetsMeQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getTimesheetsMe.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsMe.key = '/api/v1/timesheets/me';

export const getTimesheetsMeCurrent = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    getTimesheetsMeCurrent.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTimesheetsMeCurrent.key = '/api/v1/timesheets/me/current';

/**
 *
 * Retrieve multiple TransactionCategoryEntities
 */
export const getTransactionCategories = (
  queryParams?: GetTransactionCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionCategoryEntityResponseDto>> => {
  return Http.getRequest(
    getTransactionCategories.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTransactionCategories.key = '/api/v1/transaction-categories';

/**
 *
 * Retrieve a single TransactionCategoryEntity
 */
export const getTransactionCategoriesId = (
  id: string,
  queryParams?: GetTransactionCategoriesIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.getRequest(
    template(getTransactionCategoriesId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTransactionCategoriesId.key = '/api/v1/transaction-categories/{id}';

/**
 *
 * Retrieve multiple TransactionEntities
 */
export const getTransactions = (
  queryParams?: GetTransactionsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionEntityResponseDto>> => {
  return Http.getRequest(
    getTransactions.key,
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTransactions.key = '/api/v1/transactions';

/**
 *
 * Retrieve a single TransactionEntity
 */
export const getTransactionsId = (
  id: string,
  queryParams?: GetTransactionsIdQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.getRequest(
    template(getTransactionsId.key, { id }),
    queryParams,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getTransactionsId.key = '/api/v1/transactions/{id}';

export const getUsers = (
  queryParams: GetUsersQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(getUsers.key, queryParams, undefined, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
getUsers.key = '/api/v1/users';

export const getUsersId = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.getRequest(
    template(getUsersId.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getUsersId.key = '/api/v1/users/{id}';

export const getZaloBBranchRef = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<ZaloBranchDto>> => {
  return Http.getRequest(
    getZaloBBranchRef.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getZaloBBranchRef.key = '/api/v1/zalo/b/{branchRef}';

export const getZaloBBranchRefMenu = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublicMenuDto[]>> => {
  return Http.getRequest(
    getZaloBBranchRefMenu.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getZaloBBranchRefMenu.key = '/api/v1/zalo/b/{branchRef}/menu';

export const getZaloBranches = (
  queryParams?: GetZaloBranchesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloBranchListItemDto[]>> => {
  return Http.getRequest(
    getZaloBranches.key,
    queryParams,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getZaloBranches.key = '/api/v1/zalo/branches';

export const getZaloOrders = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<ZaloOrderStatusDto[]>> => {
  return Http.getRequest(
    getZaloOrders.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getZaloOrders.key = '/api/v1/zalo/orders';

export const getZaloOrdersId = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloOrderStatusDto>> => {
  return Http.getRequest(
    template(getZaloOrdersId.key, { id }),
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
getZaloOrdersId.key = '/api/v1/zalo/orders/{id}';

/**
 *
 * Update a single EmployeeDayOffEntity
 */
export const patchEmployeeDayOffId = (
  id: string,
  requestBody: EmployeeDayOffUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.patchRequest(
    template(patchEmployeeDayOffId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeeDayOffId.key = '/api/v1/employee-day-off/{id}';

/**
 *
 * Recover one EmployeeDayOffEntity
 */
export const patchEmployeeDayOffIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchEmployeeDayOffIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeeDayOffIdRecover.key = '/api/v1/employee-day-off/{id}/recover';

/**
 *
 * Update a single EmployeeRuleEntity
 */
export const patchEmployeeRulesId = (
  id: string,
  requestBody: EmployeeRuleUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.patchRequest(
    template(patchEmployeeRulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeeRulesId.key = '/api/v1/employee-rules/{id}';

/**
 *
 * Recover one EmployeeRuleEntity
 */
export const patchEmployeeRulesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchEmployeeRulesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeeRulesIdRecover.key = '/api/v1/employee-rules/{id}/recover';

/**
 *
 * Update a single EmployeeEntity
 */
export const patchEmployeesId = (
  id: string,
  requestBody: EmployeeUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.patchRequest(
    template(patchEmployeesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeesId.key = '/api/v1/employees/{id}';

/**
 *
 * Recover one EmployeeEntity
 */
export const patchEmployeesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchEmployeesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeesIdRecover.key = '/api/v1/employees/{id}/recover';

export const patchEmployeesMeProfile = (
  requestBody: EmployeeSelfProfileDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.patchRequest(
    patchEmployeesMeProfile.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchEmployeesMeProfile.key = '/api/v1/employees/me/profile';

/**
 *
 * Update a single InventoryCategoryEntity
 */
export const patchInventoryCategoriesId = (
  id: string,
  requestBody: InventoryCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.patchRequest(
    template(patchInventoryCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchInventoryCategoriesId.key = '/api/v1/inventory-categories/{id}';

/**
 *
 * Recover one InventoryCategoryEntity
 */
export const patchInventoryCategoriesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchInventoryCategoriesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchInventoryCategoriesIdRecover.key = '/api/v1/inventory-categories/{id}/recover';

/**
 *
 * Update a single InventoryItemEntity
 */
export const patchInventoryItemsId = (
  id: string,
  requestBody: InventoryItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.patchRequest(
    template(patchInventoryItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchInventoryItemsId.key = '/api/v1/inventory-items/{id}';

/**
 *
 * Recover one InventoryItemEntity
 */
export const patchInventoryItemsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchInventoryItemsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchInventoryItemsIdRecover.key = '/api/v1/inventory-items/{id}/recover';

/**
 *
 * Update a single IssueEntity
 */
export const patchIssuesId = (
  id: string,
  requestBody: IssueUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.patchRequest(
    template(patchIssuesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchIssuesId.key = '/api/v1/issues/{id}';

export const patchIssuesIdPosition = (
  id: string,
  requestBody: IssuePositionDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.patchRequest(
    template(patchIssuesIdPosition.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchIssuesIdPosition.key = '/api/v1/issues/{id}/position';

/**
 *
 * Recover one IssueEntity
 */
export const patchIssuesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchIssuesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchIssuesIdRecover.key = '/api/v1/issues/{id}/recover';

/**
 *
 * Update a single MenuEntity
 */
export const patchMenuId = (
  id: string,
  requestBody: MenuUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.patchRequest(
    template(patchMenuId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuId.key = '/api/v1/menu/{id}';

/**
 *
 * Recover one MenuEntity
 */
export const patchMenuIdRecover = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchMenuIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuIdRecover.key = '/api/v1/menu/{id}/recover';

/**
 *
 * Update a single MenuItemVariantEntity
 */
export const patchMenuItemVariantsId = (
  id: string,
  requestBody: MenuItemVariantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.patchRequest(
    template(patchMenuItemVariantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuItemVariantsId.key = '/api/v1/menu-item-variants/{id}';

/**
 *
 * Recover one MenuItemVariantEntity
 */
export const patchMenuItemVariantsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchMenuItemVariantsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuItemVariantsIdRecover.key = '/api/v1/menu-item-variants/{id}/recover';

/**
 *
 * Update a single MenuItemEntity
 */
export const patchMenuItemsId = (
  id: string,
  requestBody: MenuItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.patchRequest(
    template(patchMenuItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuItemsId.key = '/api/v1/menu-items/{id}';

/**
 *
 * Recover one MenuItemEntity
 */
export const patchMenuItemsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchMenuItemsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchMenuItemsIdRecover.key = '/api/v1/menu-items/{id}/recover';

/**
 *
 * Update a single IssueEntity
 */
export const patchOOrgSlugRRestaurantIdBBranchIdIssuesId = (
  id: string,
  requestBody: IssueUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdIssuesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdIssuesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}';

export const patchOOrgSlugRRestaurantIdBBranchIdIssuesIdPosition = (
  id: string,
  requestBody: IssuePositionDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdIssuesIdPosition.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdIssuesIdPosition.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}/position';

/**
 *
 * Recover one IssueEntity
 */
export const patchOOrgSlugRRestaurantIdBBranchIdIssuesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdIssuesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdIssuesIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}/recover';

export const patchOOrgSlugRRestaurantIdBBranchIdSchedulesId = (
  id: string,
  requestBody: UpdateShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleShiftDto>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdSchedulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdSchedulesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/{id}';

export const patchOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId = (
  id: string,
  requestBody: BreakPatchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/breaks/{id}';

export const patchOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId = (
  id: string,
  requestBody: EntryPatchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/entries/{id}';

/**
 *
 * Update a single TransactionEntity
 */
export const patchOOrgSlugRRestaurantIdBBranchIdTransactionsId = (
  id: string,
  requestBody: TransactionUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdTransactionsId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/{id}';

/**
 *
 * Recover one TransactionEntity
 */
export const patchOOrgSlugRRestaurantIdBBranchIdTransactionsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdBBranchIdTransactionsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdBBranchIdTransactionsIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/{id}/recover';

/**
 *
 * Update a single EmployeeDayOffEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeeDayOffId = (
  id: string,
  requestBody: EmployeeDayOffUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeeDayOffId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeeDayOffId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/{id}';

/**
 *
 * Recover one EmployeeDayOffEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeeDayOffIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeeDayOffIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeeDayOffIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/{id}/recover';

/**
 *
 * Update a single EmployeeRuleEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeeRulesId = (
  id: string,
  requestBody: EmployeeRuleUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeeRulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeeRulesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/{id}';

/**
 *
 * Recover one EmployeeRuleEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeeRulesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeeRulesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeeRulesIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/{id}/recover';

/**
 *
 * Update a single EmployeeEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeesId = (
  id: string,
  requestBody: EmployeeUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}';

/**
 *
 * Recover one EmployeeEntity
 */
export const patchOOrgSlugRRestaurantIdEmployeesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdEmployeesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeesIdRecover.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}/recover';

export const patchOOrgSlugRRestaurantIdEmployeesMeProfile = (
  requestBody: EmployeeSelfProfileDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.patchRequest(
    patchOOrgSlugRRestaurantIdEmployeesMeProfile.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdEmployeesMeProfile.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/me/profile';

/**
 *
 * Update a single InventoryCategoryEntity
 */
export const patchOOrgSlugRRestaurantIdInventoryCategoriesId = (
  id: string,
  requestBody: InventoryCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdInventoryCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdInventoryCategoriesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/{id}';

/**
 *
 * Recover one InventoryCategoryEntity
 */
export const patchOOrgSlugRRestaurantIdInventoryCategoriesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdInventoryCategoriesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdInventoryCategoriesIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/{id}/recover';

/**
 *
 * Update a single InventoryItemEntity
 */
export const patchOOrgSlugRRestaurantIdInventoryItemsId = (
  id: string,
  requestBody: InventoryItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdInventoryItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdInventoryItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/{id}';

/**
 *
 * Recover one InventoryItemEntity
 */
export const patchOOrgSlugRRestaurantIdInventoryItemsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdInventoryItemsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdInventoryItemsIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/{id}/recover';

/**
 *
 * Update a single MenuEntity
 */
export const patchOOrgSlugRRestaurantIdMenuId = (
  id: string,
  requestBody: MenuUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/{id}';

/**
 *
 * Recover one MenuEntity
 */
export const patchOOrgSlugRRestaurantIdMenuIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuIdRecover.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/{id}/recover';

/**
 *
 * Update a single MenuItemVariantEntity
 */
export const patchOOrgSlugRRestaurantIdMenuItemVariantsId = (
  id: string,
  requestBody: MenuItemVariantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuItemVariantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuItemVariantsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/{id}';

/**
 *
 * Recover one MenuItemVariantEntity
 */
export const patchOOrgSlugRRestaurantIdMenuItemVariantsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuItemVariantsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuItemVariantsIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/{id}/recover';

/**
 *
 * Update a single MenuItemEntity
 */
export const patchOOrgSlugRRestaurantIdMenuItemsId = (
  id: string,
  requestBody: MenuItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items/{id}';

/**
 *
 * Recover one MenuItemEntity
 */
export const patchOOrgSlugRRestaurantIdMenuItemsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdMenuItemsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdMenuItemsIdRecover.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items/{id}/recover';

/**
 *
 * Update a single RestaurantBranchEntity
 */
export const patchOOrgSlugRRestaurantIdRestaurantBranchesId = (
  id: string,
  requestBody: RestaurantBranchUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdRestaurantBranchesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdRestaurantBranchesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches/{id}';

/**
 *
 * Update a single RestaurantTableEntity
 */
export const patchOOrgSlugRRestaurantIdRestaurantTablesId = (
  id: string,
  requestBody: RestaurantTableUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdRestaurantTablesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdRestaurantTablesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables/{id}';

export const patchOOrgSlugRRestaurantIdStorefront = (
  requestBody: StorefrontUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.patchRequest(
    patchOOrgSlugRRestaurantIdStorefront.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdStorefront.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront';

export const patchOOrgSlugRRestaurantIdStorefrontBranchesBranchIdOrdering = (
  branchId: string,
  requestBody: StorefrontBranchOrderingDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdStorefrontBranchesBranchIdOrdering.key, { branchId }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdStorefrontBranchesBranchIdOrdering.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/branches/{branchId}/ordering';

/**
 *
 * Update a single StorefrontContactMessageEntity
 */
export const patchOOrgSlugRRestaurantIdStorefrontMessagesId = (
  id: string,
  requestBody: StorefrontMessageUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontContactMessageEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdStorefrontMessagesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdStorefrontMessagesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/messages/{id}';

/**
 *
 * Update a single StorefrontPostEntity
 */
export const patchOOrgSlugRRestaurantIdStorefrontPostsId = (
  id: string,
  requestBody: StorefrontPostUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPostEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdStorefrontPostsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdStorefrontPostsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/posts/{id}';

export const patchOOrgSlugRRestaurantIdTimesheetsMeEntriesIdNote = (
  id: string,
  requestBody: EmployeeNoteDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdTimesheetsMeEntriesIdNote.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdTimesheetsMeEntriesIdNote.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/entries/{id}/note';

/**
 *
 * Update a single TransactionCategoryEntity
 */
export const patchOOrgSlugRRestaurantIdTransactionCategoriesId = (
  id: string,
  requestBody: TransactionCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdTransactionCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdTransactionCategoriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/{id}';

/**
 *
 * Recover one TransactionCategoryEntity
 */
export const patchOOrgSlugRRestaurantIdTransactionCategoriesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRRestaurantIdTransactionCategoriesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRRestaurantIdTransactionCategoriesIdRecover.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/{id}/recover';

/**
 *
 * Update a single RestaurantEntity
 */
export const patchOOrgSlugRestaurantsId = (
  id: string,
  requestBody: RestaurantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.patchRequest(
    template(patchOOrgSlugRestaurantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchOOrgSlugRestaurantsId.key = '/api/v1/o/{orgSlug}/restaurants/{id}';

/**
 *
 * Update a single RestaurantBranchEntity
 */
export const patchRestaurantBranchesId = (
  id: string,
  requestBody: RestaurantBranchUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.patchRequest(
    template(patchRestaurantBranchesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchRestaurantBranchesId.key = '/api/v1/restaurant-branches/{id}';

/**
 *
 * Update a single RestaurantTableEntity
 */
export const patchRestaurantTablesId = (
  id: string,
  requestBody: RestaurantTableUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.patchRequest(
    template(patchRestaurantTablesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchRestaurantTablesId.key = '/api/v1/restaurant-tables/{id}';

/**
 *
 * Update a single RestaurantEntity
 */
export const patchRestaurantsId = (
  id: string,
  requestBody: RestaurantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.patchRequest(
    template(patchRestaurantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchRestaurantsId.key = '/api/v1/restaurants/{id}';

export const patchSchedulesId = (
  id: string,
  requestBody: UpdateShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleShiftDto>> => {
  return Http.patchRequest(
    template(patchSchedulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchSchedulesId.key = '/api/v1/schedules/{id}';

export const patchStorefront = (
  requestBody: StorefrontUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.patchRequest(
    patchStorefront.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchStorefront.key = '/api/v1/storefront';

export const patchStorefrontBranchesBranchIdOrdering = (
  branchId: string,
  requestBody: StorefrontBranchOrderingDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.patchRequest(
    template(patchStorefrontBranchesBranchIdOrdering.key, { branchId }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchStorefrontBranchesBranchIdOrdering.key = '/api/v1/storefront/branches/{branchId}/ordering';

/**
 *
 * Update a single StorefrontContactMessageEntity
 */
export const patchStorefrontMessagesId = (
  id: string,
  requestBody: StorefrontMessageUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontContactMessageEntity>> => {
  return Http.patchRequest(
    template(patchStorefrontMessagesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchStorefrontMessagesId.key = '/api/v1/storefront/messages/{id}';

/**
 *
 * Update a single StorefrontPostEntity
 */
export const patchStorefrontPostsId = (
  id: string,
  requestBody: StorefrontPostUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPostEntity>> => {
  return Http.patchRequest(
    template(patchStorefrontPostsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchStorefrontPostsId.key = '/api/v1/storefront/posts/{id}';

export const patchTimesheetsBreaksId = (
  id: string,
  requestBody: BreakPatchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchTimesheetsBreaksId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTimesheetsBreaksId.key = '/api/v1/timesheets/breaks/{id}';

export const patchTimesheetsEntriesId = (
  id: string,
  requestBody: EntryPatchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchTimesheetsEntriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTimesheetsEntriesId.key = '/api/v1/timesheets/entries/{id}';

export const patchTimesheetsMeEntriesIdNote = (
  id: string,
  requestBody: EmployeeNoteDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchTimesheetsMeEntriesIdNote.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTimesheetsMeEntriesIdNote.key = '/api/v1/timesheets/me/entries/{id}/note';

/**
 *
 * Update a single TransactionCategoryEntity
 */
export const patchTransactionCategoriesId = (
  id: string,
  requestBody: TransactionCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.patchRequest(
    template(patchTransactionCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTransactionCategoriesId.key = '/api/v1/transaction-categories/{id}';

/**
 *
 * Recover one TransactionCategoryEntity
 */
export const patchTransactionCategoriesIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchTransactionCategoriesIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTransactionCategoriesIdRecover.key = '/api/v1/transaction-categories/{id}/recover';

/**
 *
 * Update a single TransactionEntity
 */
export const patchTransactionsId = (
  id: string,
  requestBody: TransactionUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.patchRequest(
    template(patchTransactionsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTransactionsId.key = '/api/v1/transactions/{id}';

/**
 *
 * Recover one TransactionEntity
 */
export const patchTransactionsIdRecover = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchTransactionsIdRecover.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchTransactionsIdRecover.key = '/api/v1/transactions/{id}/recover';

export const patchUsersId = (
  id: string,
  requestBody: UpdateUserDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.patchRequest(
    template(patchUsersId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
patchUsersId.key = '/api/v1/users/{id}';

export const postAuthAdminEmailLogin = (
  requestBody: AuthEmailLoginDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<AuthEmailLoginResponse>> => {
  return Http.postRequest(
    postAuthAdminEmailLogin.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postAuthAdminEmailLogin.key = '/api/v1/auth/admin/email/login';

export const postAuthEmailLogin = (
  requestBody: AuthEmailLoginDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<AuthEmailLoginResponse>> => {
  return Http.postRequest(
    postAuthEmailLogin.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postAuthEmailLogin.key = '/api/v1/auth/email/login';

export const postBankingNotifications = (
  requestBody: CreateBankingNotificationDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postBankingNotifications.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postBankingNotifications.key = '/api/v1/banking/notifications';

export const postE2eClearTestRecords = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postE2eClearTestRecords.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postE2eClearTestRecords.key = '/api/v1/e2e/clear-test-records';

export const postE2ePurgeFixtures = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postE2ePurgeFixtures.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postE2ePurgeFixtures.key = '/api/v1/e2e/purge-fixtures';

export const postE2eResetOnboarding = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postE2eResetOnboarding.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postE2eResetOnboarding.key = '/api/v1/e2e/reset-onboarding';

/**
 *
 * Create a single EmployeeDayOffEntity
 */
export const postEmployeeDayOff = (
  requestBody: EmployeeDayOffCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postEmployeeDayOff.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployeeDayOff.key = '/api/v1/employee-day-off';

/**
 *
 * Create multiple EmployeeDayOffEntities
 */
export const postEmployeeDayOffBulk = (
  requestBody: CreateManyEmployeeDayOffEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postEmployeeDayOffBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployeeDayOffBulk.key = '/api/v1/employee-day-off/bulk';

/**
 *
 * Create a single EmployeeRuleEntity
 */
export const postEmployeeRules = (
  requestBody: EmployeeRuleCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postEmployeeRules.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployeeRules.key = '/api/v1/employee-rules';

/**
 *
 * Create multiple EmployeeRuleEntities
 */
export const postEmployeeRulesBulk = (
  requestBody: CreateManyEmployeeRuleEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postEmployeeRulesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployeeRulesBulk.key = '/api/v1/employee-rules/bulk';

/**
 *
 * Create a single EmployeeEntity
 */
export const postEmployees = (
  requestBody: EmployeeCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postEmployees.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployees.key = '/api/v1/employees';

export const postEmployeesIdInvited = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.postRequest(
    template(postEmployeesIdInvited.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postEmployeesIdInvited.key = '/api/v1/employees/{id}/invited';

/**
 *
 * Create a single InventoryCategoryEntity
 */
export const postInventoryCategories = (
  requestBody: InventoryCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postInventoryCategories.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postInventoryCategories.key = '/api/v1/inventory-categories';

/**
 *
 * Create multiple InventoryCategoryEntities
 */
export const postInventoryCategoriesBulk = (
  requestBody: CreateManyInventoryCategoryEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postInventoryCategoriesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postInventoryCategoriesBulk.key = '/api/v1/inventory-categories/bulk';

/**
 *
 * Create a single InventoryItemEntity
 */
export const postInventoryItems = (
  requestBody: InventoryItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postInventoryItems.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postInventoryItems.key = '/api/v1/inventory-items';

/**
 *
 * Create multiple InventoryItemEntities
 */
export const postInventoryItemsBulk = (
  requestBody: CreateManyInventoryItemEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postInventoryItemsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postInventoryItemsBulk.key = '/api/v1/inventory-items/bulk';

/**
 *
 * Create a single InventoryMovementEntity
 */
export const postInventoryMovements = (
  requestBody: InventoryMovementCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postInventoryMovements.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postInventoryMovements.key = '/api/v1/inventory-movements';

/**
 *
 * Create a single IssueEntity
 */
export const postIssues = (
  requestBody: IssueCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postIssues.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postIssues.key = '/api/v1/issues';

/**
 *
 * Create multiple IssueEntities
 */
export const postIssuesBulk = (
  requestBody: CreateManyIssueEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postIssuesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postIssuesBulk.key = '/api/v1/issues/bulk';

export const postMediaUploadUrl = (
  requestBody: CreateUploadUrlDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<UploadUrlResponse>> => {
  return Http.postRequest(
    postMediaUploadUrl.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postMediaUploadUrl.key = '/api/v1/media/upload-url';

/**
 *
 * Create a single MenuEntity
 */
export const postMenu = (
  requestBody: MenuCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(postMenu.key, undefined, requestBody, _CONSTANT1, overrideConfig(_CONSTANT0, configOverride));
};

/** Key is end point string without base url */
postMenu.key = '/api/v1/menu';

/**
 *
 * Create multiple MenuEntities
 */
export const postMenuBulk = (
  requestBody: CreateManyMenuEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postMenuBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postMenuBulk.key = '/api/v1/menu/bulk';

/**
 *
 * Create a single MenuItemVariantEntity
 */
export const postMenuItemVariants = (
  requestBody: MenuItemVariantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postMenuItemVariants.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postMenuItemVariants.key = '/api/v1/menu-item-variants';

/**
 *
 * Create multiple MenuItemVariantEntities
 */
export const postMenuItemVariantsBulk = (
  requestBody: CreateManyMenuItemVariantEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postMenuItemVariantsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postMenuItemVariantsBulk.key = '/api/v1/menu-item-variants/bulk';

/**
 *
 * Create a single MenuItemEntity
 */
export const postMenuItems = (
  requestBody: MenuItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postMenuItems.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postMenuItems.key = '/api/v1/menu-items';

export const postOOrgSlugBillingCheckout = (
  requestBody: BillingCheckoutDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<BillingRedirectDto>> => {
  return Http.postRequest(
    postOOrgSlugBillingCheckout.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugBillingCheckout.key = '/api/v1/o/{orgSlug}/billing/checkout';

export const postOOrgSlugBillingPortal = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<BillingRedirectDto>> => {
  return Http.postRequest(
    postOOrgSlugBillingPortal.key,
    undefined,
    undefined,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugBillingPortal.key = '/api/v1/o/{orgSlug}/billing/portal';

/**
 *
 * Create a single InventoryMovementEntity
 */
export const postOOrgSlugRRestaurantIdBBranchIdInventoryMovements = (
  requestBody: InventoryMovementCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/inventory-movements';

/**
 *
 * Create a single IssueEntity
 */
export const postOOrgSlugRRestaurantIdBBranchIdIssues = (
  requestBody: IssueCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdIssues.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdIssues.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues';

/**
 *
 * Create multiple IssueEntities
 */
export const postOOrgSlugRRestaurantIdBBranchIdIssuesBulk = (
  requestBody: CreateManyIssueEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdIssuesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdIssuesBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/bulk';

export const postOOrgSlugRRestaurantIdBBranchIdOrders = (
  requestBody: OrderCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdOrders.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdOrders.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders';

export const postOOrgSlugRRestaurantIdBBranchIdSchedules = (
  requestBody: CreateShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdSchedules.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdSchedules.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules';

export const postOOrgSlugRRestaurantIdBBranchIdSchedulesCopy = (
  requestBody: CopyWeekDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<CopyResultDto>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdSchedulesCopy.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdSchedulesCopy.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/copy';

export const postOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssign = (
  id: string,
  requestBody: AssignShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleShiftDto>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssign.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssign.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/{id}/assign';

export const postOOrgSlugRRestaurantIdBBranchIdSchedulesPublish = (
  requestBody: PublishWeekDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublishResultDto>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdSchedulesPublish.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdSchedulesPublish.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/schedules/publish';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntries = (
  requestBody: ManualEntryDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntries.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntries.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/entries';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdBreaks = (
  id: string,
  requestBody: BreakDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdBreaks.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdBreaks.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/entries/{id}/breaks';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdScheduleLink = (
  id: string,
  requestBody: ScheduleLinkDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EntryScheduleDto>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdScheduleLink.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdScheduleLink.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/entries/{id}/schedule-link';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdApprove = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdApprove.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdApprove.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/{id}/approve';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdPay = (
  id: string,
  requestBody: PayDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdPay.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdPay.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/{id}/pay';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdReopen = (
  id: string,
  requestBody: ReopenDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdReopen.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdReopen.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/{id}/reopen';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskConfirm = (
  requestBody: KioskConfirmDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskConfirm.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskConfirm.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/kiosk/confirm';

export const postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskPunch = (
  requestBody: KioskPunchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskPunch.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskPunch.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/timesheets/kiosk/punch';

/**
 *
 * Create a single TransactionEntity
 */
export const postOOrgSlugRRestaurantIdBBranchIdTransactions = (
  requestBody: TransactionCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdTransactions.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTransactions.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions';

/**
 *
 * Create multiple TransactionEntities
 */
export const postOOrgSlugRRestaurantIdBBranchIdTransactionsBulk = (
  requestBody: CreateManyTransactionEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdBBranchIdTransactionsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdBBranchIdTransactionsBulk.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/bulk';

/**
 *
 * Create a single EmployeeDayOffEntity
 */
export const postOOrgSlugRRestaurantIdEmployeeDayOff = (
  requestBody: EmployeeDayOffCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdEmployeeDayOff.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployeeDayOff.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off';

/**
 *
 * Create multiple EmployeeDayOffEntities
 */
export const postOOrgSlugRRestaurantIdEmployeeDayOffBulk = (
  requestBody: CreateManyEmployeeDayOffEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdEmployeeDayOffBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployeeDayOffBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/bulk';

/**
 *
 * Create a single EmployeeRuleEntity
 */
export const postOOrgSlugRRestaurantIdEmployeeRules = (
  requestBody: EmployeeRuleCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdEmployeeRules.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployeeRules.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules';

/**
 *
 * Create multiple EmployeeRuleEntities
 */
export const postOOrgSlugRRestaurantIdEmployeeRulesBulk = (
  requestBody: CreateManyEmployeeRuleEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdEmployeeRulesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployeeRulesBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/bulk';

/**
 *
 * Create a single EmployeeEntity
 */
export const postOOrgSlugRRestaurantIdEmployees = (
  requestBody: EmployeeCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdEmployees.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployees.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees';

export const postOOrgSlugRRestaurantIdEmployeesIdInvited = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdEmployeesIdInvited.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdEmployeesIdInvited.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}/invited';

/**
 *
 * Create a single InventoryCategoryEntity
 */
export const postOOrgSlugRRestaurantIdInventoryCategories = (
  requestBody: InventoryCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdInventoryCategories.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdInventoryCategories.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories';

/**
 *
 * Create multiple InventoryCategoryEntities
 */
export const postOOrgSlugRRestaurantIdInventoryCategoriesBulk = (
  requestBody: CreateManyInventoryCategoryEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdInventoryCategoriesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdInventoryCategoriesBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/bulk';

/**
 *
 * Create a single InventoryItemEntity
 */
export const postOOrgSlugRRestaurantIdInventoryItems = (
  requestBody: InventoryItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdInventoryItems.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdInventoryItems.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items';

/**
 *
 * Create multiple InventoryItemEntities
 */
export const postOOrgSlugRRestaurantIdInventoryItemsBulk = (
  requestBody: CreateManyInventoryItemEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdInventoryItemsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdInventoryItemsBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/bulk';

/**
 *
 * Create a single MenuEntity
 */
export const postOOrgSlugRRestaurantIdMenu = (
  requestBody: MenuCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdMenu.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdMenu.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu';

/**
 *
 * Create multiple MenuEntities
 */
export const postOOrgSlugRRestaurantIdMenuBulk = (
  requestBody: CreateManyMenuEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdMenuBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdMenuBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/bulk';

/**
 *
 * Create a single MenuItemVariantEntity
 */
export const postOOrgSlugRRestaurantIdMenuItemVariants = (
  requestBody: MenuItemVariantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdMenuItemVariants.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdMenuItemVariants.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants';

/**
 *
 * Create multiple MenuItemVariantEntities
 */
export const postOOrgSlugRRestaurantIdMenuItemVariantsBulk = (
  requestBody: CreateManyMenuItemVariantEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdMenuItemVariantsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdMenuItemVariantsBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/bulk';

/**
 *
 * Create a single MenuItemEntity
 */
export const postOOrgSlugRRestaurantIdMenuItems = (
  requestBody: MenuItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdMenuItems.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdMenuItems.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items';

/**
 *
 * Create a single RestaurantBranchEntity
 */
export const postOOrgSlugRRestaurantIdRestaurantBranches = (
  requestBody: RestaurantBranchCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdRestaurantBranches.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdRestaurantBranches.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches';

/**
 *
 * Create a single RestaurantTableEntity
 */
export const postOOrgSlugRRestaurantIdRestaurantTables = (
  requestBody: RestaurantTableCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdRestaurantTables.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdRestaurantTables.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables';

/**
 *
 * Create multiple RestaurantTableEntities
 */
export const postOOrgSlugRRestaurantIdRestaurantTablesBulk = (
  requestBody: CreateManyRestaurantTableEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdRestaurantTablesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdRestaurantTablesBulk.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables/bulk';

export const postOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister = (
  shiftId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MyScheduleShiftDto>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key, { shiftId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/schedules/me/{shiftId}/register';

/**
 *
 * Create a single StorefrontPostEntity
 */
export const postOOrgSlugRRestaurantIdStorefrontPosts = (
  requestBody: StorefrontPostCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdStorefrontPosts.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdStorefrontPosts.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/posts';

export const postOOrgSlugRRestaurantIdStorefrontPreviewLink = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPreviewLinkDto>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdStorefrontPreviewLink.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdStorefrontPreviewLink.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/preview-link';

export const postOOrgSlugRRestaurantIdStorefrontPublish = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdStorefrontPublish.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdStorefrontPublish.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/publish';

export const postOOrgSlugRRestaurantIdStorefrontUnpublish = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdStorefrontUnpublish.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdStorefrontUnpublish.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/storefront/unpublish';

export const postOOrgSlugRRestaurantIdTimesheetsHolidays = (
  requestBody: TimesheetHolidayEntity,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsHolidays.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsHolidays.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/holidays';

export const postOOrgSlugRRestaurantIdTimesheetsHolidaysLoadVn = (
  requestBody: LoadVnHolidaysDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsHolidaysLoadVn.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsHolidaysLoadVn.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/holidays/load-vn';

export const postOOrgSlugRRestaurantIdTimesheetsMeBreakEnd = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsMeBreakEnd.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsMeBreakEnd.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/break/end';

export const postOOrgSlugRRestaurantIdTimesheetsMeBreakStart = (
  requestBody: BreakStartDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsMeBreakStart.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsMeBreakStart.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/break/start';

export const postOOrgSlugRRestaurantIdTimesheetsMeClockIn = (
  requestBody: ClockInDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsMeClockIn.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsMeClockIn.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/clock-in';

export const postOOrgSlugRRestaurantIdTimesheetsMeClockOut = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTimesheetsMeClockOut.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsMeClockOut.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/clock-out';

export const postOOrgSlugRRestaurantIdTimesheetsMeIdConfirm = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postOOrgSlugRRestaurantIdTimesheetsMeIdConfirm.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTimesheetsMeIdConfirm.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/timesheets/me/{id}/confirm';

/**
 *
 * Create a single TransactionCategoryEntity
 */
export const postOOrgSlugRRestaurantIdTransactionCategories = (
  requestBody: TransactionCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTransactionCategories.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTransactionCategories.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories';

/**
 *
 * Create multiple TransactionCategoryEntities
 */
export const postOOrgSlugRRestaurantIdTransactionCategoriesBulk = (
  requestBody: CreateManyTransactionCategoryEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRRestaurantIdTransactionCategoriesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRRestaurantIdTransactionCategoriesBulk.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/bulk';

/**
 *
 * Create a single RestaurantEntity
 */
export const postOOrgSlugRestaurants = (
  requestBody: RestaurantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOOrgSlugRestaurants.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOOrgSlugRestaurants.key = '/api/v1/o/{orgSlug}/restaurants';

export const postOrders = (
  requestBody: OrderCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postOrders.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postOrders.key = '/api/v1/orders';

export const postPublicBBranchRefOrders = (
  requestBody: PublicOrderCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postPublicBBranchRefOrders.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postPublicBBranchRefOrders.key = '/api/v1/public/b/{branchRef}/orders';

export const postPublicMarketingContact = (
  requestBody: MarketingContactDto,
  headerParams?: { 'user-agent': string },
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postPublicMarketingContact.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(
      {
        headers: {
          ..._CONSTANT2,
          ...headerParams,
        },
      },
      configOverride
    )
  );
};

/** Key is end point string without base url */
postPublicMarketingContact.key = '/api/v1/public/marketing/contact';

export const postPublicStorefrontsStorefrontSlugContact = (
  requestBody: PublicStorefrontContactDto,
  headerParams?: { 'user-agent': string },
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postPublicStorefrontsStorefrontSlugContact.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(
      {
        headers: {
          ..._CONSTANT2,
          ...headerParams,
        },
      },
      configOverride
    )
  );
};

/** Key is end point string without base url */
postPublicStorefrontsStorefrontSlugContact.key = '/api/v1/public/storefronts/{storefrontSlug}/contact';

/**
 *
 * Create a single RestaurantBranchEntity
 */
export const postRestaurantBranches = (
  requestBody: RestaurantBranchCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postRestaurantBranches.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postRestaurantBranches.key = '/api/v1/restaurant-branches';

/**
 *
 * Create a single RestaurantTableEntity
 */
export const postRestaurantTables = (
  requestBody: RestaurantTableCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postRestaurantTables.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postRestaurantTables.key = '/api/v1/restaurant-tables';

/**
 *
 * Create multiple RestaurantTableEntities
 */
export const postRestaurantTablesBulk = (
  requestBody: CreateManyRestaurantTableEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postRestaurantTablesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postRestaurantTablesBulk.key = '/api/v1/restaurant-tables/bulk';

/**
 *
 * Create a single RestaurantEntity
 */
export const postRestaurants = (
  requestBody: RestaurantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postRestaurants.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postRestaurants.key = '/api/v1/restaurants';

export const postSchedules = (
  requestBody: CreateShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postSchedules.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postSchedules.key = '/api/v1/schedules';

export const postSchedulesCopy = (
  requestBody: CopyWeekDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<CopyResultDto>> => {
  return Http.postRequest(
    postSchedulesCopy.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postSchedulesCopy.key = '/api/v1/schedules/copy';

export const postSchedulesIdAssign = (
  id: string,
  requestBody: AssignShiftDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ScheduleShiftDto>> => {
  return Http.postRequest(
    template(postSchedulesIdAssign.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postSchedulesIdAssign.key = '/api/v1/schedules/{id}/assign';

export const postSchedulesMeShiftIdRegister = (
  shiftId: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MyScheduleShiftDto>> => {
  return Http.postRequest(
    template(postSchedulesMeShiftIdRegister.key, { shiftId }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postSchedulesMeShiftIdRegister.key = '/api/v1/schedules/me/{shiftId}/register';

export const postSchedulesPublish = (
  requestBody: PublishWeekDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<PublishResultDto>> => {
  return Http.postRequest(
    postSchedulesPublish.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postSchedulesPublish.key = '/api/v1/schedules/publish';

/**
 *
 * Create a single StorefrontPostEntity
 */
export const postStorefrontPosts = (
  requestBody: StorefrontPostCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postStorefrontPosts.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postStorefrontPosts.key = '/api/v1/storefront/posts';

export const postStorefrontPreviewLink = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPreviewLinkDto>> => {
  return Http.postRequest(
    postStorefrontPreviewLink.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postStorefrontPreviewLink.key = '/api/v1/storefront/preview-link';

export const postStorefrontPublish = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.postRequest(
    postStorefrontPublish.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postStorefrontPublish.key = '/api/v1/storefront/publish';

export const postStorefrontUnpublish = (
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> => {
  return Http.postRequest(
    postStorefrontUnpublish.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postStorefrontUnpublish.key = '/api/v1/storefront/unpublish';

export const postTimesheetsEntries = (
  requestBody: ManualEntryDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsEntries.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsEntries.key = '/api/v1/timesheets/entries';

export const postTimesheetsEntriesIdBreaks = (
  id: string,
  requestBody: BreakDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postTimesheetsEntriesIdBreaks.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsEntriesIdBreaks.key = '/api/v1/timesheets/entries/{id}/breaks';

export const postTimesheetsEntriesIdScheduleLink = (
  id: string,
  requestBody: ScheduleLinkDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EntryScheduleDto>> => {
  return Http.postRequest(
    template(postTimesheetsEntriesIdScheduleLink.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsEntriesIdScheduleLink.key = '/api/v1/timesheets/entries/{id}/schedule-link';

export const postTimesheetsHolidays = (
  requestBody: TimesheetHolidayEntity,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsHolidays.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsHolidays.key = '/api/v1/timesheets/holidays';

export const postTimesheetsHolidaysLoadVn = (
  requestBody: LoadVnHolidaysDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsHolidaysLoadVn.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsHolidaysLoadVn.key = '/api/v1/timesheets/holidays/load-vn';

export const postTimesheetsIdApprove = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postTimesheetsIdApprove.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsIdApprove.key = '/api/v1/timesheets/{id}/approve';

export const postTimesheetsIdPay = (
  id: string,
  requestBody: PayDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postTimesheetsIdPay.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsIdPay.key = '/api/v1/timesheets/{id}/pay';

export const postTimesheetsIdReopen = (
  id: string,
  requestBody: ReopenDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postTimesheetsIdReopen.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsIdReopen.key = '/api/v1/timesheets/{id}/reopen';

export const postTimesheetsKioskConfirm = (
  requestBody: KioskConfirmDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsKioskConfirm.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsKioskConfirm.key = '/api/v1/timesheets/kiosk/confirm';

export const postTimesheetsKioskPunch = (
  requestBody: KioskPunchDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsKioskPunch.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsKioskPunch.key = '/api/v1/timesheets/kiosk/punch';

export const postTimesheetsMeBreakEnd = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsMeBreakEnd.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsMeBreakEnd.key = '/api/v1/timesheets/me/break/end';

export const postTimesheetsMeBreakStart = (
  requestBody: BreakStartDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsMeBreakStart.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsMeBreakStart.key = '/api/v1/timesheets/me/break/start';

export const postTimesheetsMeClockIn = (
  requestBody: ClockInDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsMeClockIn.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsMeClockIn.key = '/api/v1/timesheets/me/clock-in';

export const postTimesheetsMeClockOut = (configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTimesheetsMeClockOut.key,
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsMeClockOut.key = '/api/v1/timesheets/me/clock-out';

export const postTimesheetsMeIdConfirm = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    template(postTimesheetsMeIdConfirm.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTimesheetsMeIdConfirm.key = '/api/v1/timesheets/me/{id}/confirm';

/**
 *
 * Create a single TransactionCategoryEntity
 */
export const postTransactionCategories = (
  requestBody: TransactionCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTransactionCategories.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTransactionCategories.key = '/api/v1/transaction-categories';

/**
 *
 * Create multiple TransactionCategoryEntities
 */
export const postTransactionCategoriesBulk = (
  requestBody: CreateManyTransactionCategoryEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTransactionCategoriesBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTransactionCategoriesBulk.key = '/api/v1/transaction-categories/bulk';

/**
 *
 * Create a single TransactionEntity
 */
export const postTransactions = (
  requestBody: TransactionCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTransactions.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTransactions.key = '/api/v1/transactions';

/**
 *
 * Create multiple TransactionEntities
 */
export const postTransactionsBulk = (
  requestBody: CreateManyTransactionEntityDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postTransactionsBulk.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postTransactionsBulk.key = '/api/v1/transactions/bulk';

export const postUsers = (
  requestBody: CreateUserDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postUsers.key,
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postUsers.key = '/api/v1/users';

export const postZaloAuthSession = (
  requestBody: ZaloSessionCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postZaloAuthSession.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postZaloAuthSession.key = '/api/v1/zalo/auth/session';

export const postZaloBBranchRefOrders = (
  requestBody: ZaloOrderCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.postRequest(
    postZaloBBranchRefOrders.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postZaloBBranchRefOrders.key = '/api/v1/zalo/b/{branchRef}/orders';

export const postZaloProfileLocation = (
  requestBody: ZaloTokenRedeemDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloLocationDto>> => {
  return Http.postRequest(
    postZaloProfileLocation.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postZaloProfileLocation.key = '/api/v1/zalo/profile/location';

export const postZaloProfilePhone = (
  requestBody: ZaloTokenRedeemDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloPhoneDto>> => {
  return Http.postRequest(
    postZaloProfilePhone.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
postZaloProfilePhone.key = '/api/v1/zalo/profile/phone';

/**
 *
 * Replace a single EmployeeDayOffEntity
 */
export const putEmployeeDayOffId = (
  id: string,
  requestBody: EmployeeDayOffUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.putRequest(
    template(putEmployeeDayOffId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putEmployeeDayOffId.key = '/api/v1/employee-day-off/{id}';

/**
 *
 * Replace a single EmployeeRuleEntity
 */
export const putEmployeeRulesId = (
  id: string,
  requestBody: EmployeeRuleUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.putRequest(
    template(putEmployeeRulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putEmployeeRulesId.key = '/api/v1/employee-rules/{id}';

/**
 *
 * Replace a single EmployeeEntity
 */
export const putEmployeesId = (
  id: string,
  requestBody: EmployeeUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.putRequest(
    template(putEmployeesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putEmployeesId.key = '/api/v1/employees/{id}';

export const putEmployeesIdTimesheetPin = (
  id: string,
  requestBody: PinDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putEmployeesIdTimesheetPin.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putEmployeesIdTimesheetPin.key = '/api/v1/employees/{id}/timesheet-pin';

export const putIntegrationsZalo = (
  requestBody: ZaloIntegrationWriteDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> => {
  return Http.putRequest(
    putIntegrationsZalo.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putIntegrationsZalo.key = '/api/v1/integrations/zalo';

/**
 *
 * Replace a single InventoryCategoryEntity
 */
export const putInventoryCategoriesId = (
  id: string,
  requestBody: InventoryCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.putRequest(
    template(putInventoryCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putInventoryCategoriesId.key = '/api/v1/inventory-categories/{id}';

/**
 *
 * Replace a single InventoryItemEntity
 */
export const putInventoryItemsId = (
  id: string,
  requestBody: InventoryItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.putRequest(
    template(putInventoryItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putInventoryItemsId.key = '/api/v1/inventory-items/{id}';

/**
 *
 * Replace a single IssueEntity
 */
export const putIssuesId = (
  id: string,
  requestBody: IssueUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.putRequest(
    template(putIssuesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putIssuesId.key = '/api/v1/issues/{id}';

/**
 *
 * Replace a single MenuEntity
 */
export const putMenuId = (
  id: string,
  requestBody: MenuUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.putRequest(
    template(putMenuId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putMenuId.key = '/api/v1/menu/{id}';

/**
 *
 * Replace a single MenuItemVariantEntity
 */
export const putMenuItemVariantsId = (
  id: string,
  requestBody: MenuItemVariantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.putRequest(
    template(putMenuItemVariantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putMenuItemVariantsId.key = '/api/v1/menu-item-variants/{id}';

/**
 *
 * Replace a single MenuItemEntity
 */
export const putMenuItemsId = (
  id: string,
  requestBody: MenuItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.putRequest(
    template(putMenuItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putMenuItemsId.key = '/api/v1/menu-items/{id}';

export const putOOrgSlugIntegrationsZalo = (
  requestBody: ZaloIntegrationWriteDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> => {
  return Http.putRequest(
    putOOrgSlugIntegrationsZalo.key,
    undefined,
    requestBody,
    undefined,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugIntegrationsZalo.key = '/api/v1/o/{orgSlug}/integrations/zalo';

/**
 *
 * Replace a single IssueEntity
 */
export const putOOrgSlugRRestaurantIdBBranchIdIssuesId = (
  id: string,
  requestBody: IssueUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdBBranchIdIssuesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdBBranchIdIssuesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/issues/{id}';

export const putOOrgSlugRRestaurantIdBBranchIdOrdersId = (
  id: string,
  requestBody: OrderUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdBBranchIdOrdersId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdBBranchIdOrdersId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/{id}';

export const putOOrgSlugRRestaurantIdBBranchIdOrdersIdAccept = (
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdBBranchIdOrdersIdAccept.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdBBranchIdOrdersIdAccept.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/{id}/accept';

export const putOOrgSlugRRestaurantIdBBranchIdOrdersIdReject = (
  id: string,
  requestBody: OrderRejectionDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdBBranchIdOrdersIdReject.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdBBranchIdOrdersIdReject.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/orders/{id}/reject';

/**
 *
 * Replace a single TransactionEntity
 */
export const putOOrgSlugRRestaurantIdBBranchIdTransactionsId = (
  id: string,
  requestBody: TransactionUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdBBranchIdTransactionsId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/b/{branchId}/transactions/{id}';

/**
 *
 * Replace a single EmployeeDayOffEntity
 */
export const putOOrgSlugRRestaurantIdEmployeeDayOffId = (
  id: string,
  requestBody: EmployeeDayOffUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdEmployeeDayOffId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdEmployeeDayOffId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-day-off/{id}';

/**
 *
 * Replace a single EmployeeRuleEntity
 */
export const putOOrgSlugRRestaurantIdEmployeeRulesId = (
  id: string,
  requestBody: EmployeeRuleUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdEmployeeRulesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdEmployeeRulesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employee-rules/{id}';

/**
 *
 * Replace a single EmployeeEntity
 */
export const putOOrgSlugRRestaurantIdEmployeesId = (
  id: string,
  requestBody: EmployeeUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdEmployeesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdEmployeesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}';

export const putOOrgSlugRRestaurantIdEmployeesIdTimesheetPin = (
  id: string,
  requestBody: PinDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/employees/{id}/timesheet-pin';

/**
 *
 * Replace a single InventoryCategoryEntity
 */
export const putOOrgSlugRRestaurantIdInventoryCategoriesId = (
  id: string,
  requestBody: InventoryCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdInventoryCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdInventoryCategoriesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-categories/{id}';

/**
 *
 * Replace a single InventoryItemEntity
 */
export const putOOrgSlugRRestaurantIdInventoryItemsId = (
  id: string,
  requestBody: InventoryItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdInventoryItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdInventoryItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/inventory-items/{id}';

/**
 *
 * Replace a single MenuEntity
 */
export const putOOrgSlugRRestaurantIdMenuId = (
  id: string,
  requestBody: MenuUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdMenuId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdMenuId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu/{id}';

/**
 *
 * Replace a single MenuItemVariantEntity
 */
export const putOOrgSlugRRestaurantIdMenuItemVariantsId = (
  id: string,
  requestBody: MenuItemVariantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdMenuItemVariantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdMenuItemVariantsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-item-variants/{id}';

/**
 *
 * Replace a single MenuItemEntity
 */
export const putOOrgSlugRRestaurantIdMenuItemsId = (
  id: string,
  requestBody: MenuItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdMenuItemsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdMenuItemsId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/menu-items/{id}';

/**
 *
 * Replace a single RestaurantBranchEntity
 */
export const putOOrgSlugRRestaurantIdRestaurantBranchesId = (
  id: string,
  requestBody: RestaurantBranchUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdRestaurantBranchesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdRestaurantBranchesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-branches/{id}';

/**
 *
 * Replace a single RestaurantTableEntity
 */
export const putOOrgSlugRRestaurantIdRestaurantTablesId = (
  id: string,
  requestBody: RestaurantTableUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdRestaurantTablesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdRestaurantTablesId.key = '/api/v1/o/{orgSlug}/r/{restaurantId}/restaurant-tables/{id}';

/**
 *
 * Replace a single TransactionCategoryEntity
 */
export const putOOrgSlugRRestaurantIdTransactionCategoriesId = (
  id: string,
  requestBody: TransactionCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRRestaurantIdTransactionCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRRestaurantIdTransactionCategoriesId.key =
  '/api/v1/o/{orgSlug}/r/{restaurantId}/transaction-categories/{id}';

/**
 *
 * Replace a single RestaurantEntity
 */
export const putOOrgSlugRestaurantsId = (
  id: string,
  requestBody: RestaurantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.putRequest(
    template(putOOrgSlugRestaurantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOOrgSlugRestaurantsId.key = '/api/v1/o/{orgSlug}/restaurants/{id}';

export const putOrdersId = (
  id: string,
  requestBody: OrderUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOrdersId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOrdersId.key = '/api/v1/orders/{id}';

export const putOrdersIdAccept = (id: string, configOverride?: AxiosRequestConfig): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOrdersIdAccept.key, { id }),
    undefined,
    undefined,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOrdersIdAccept.key = '/api/v1/orders/{id}/accept';

export const putOrdersIdReject = (
  id: string,
  requestBody: OrderRejectionDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> => {
  return Http.putRequest(
    template(putOrdersIdReject.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putOrdersIdReject.key = '/api/v1/orders/{id}/reject';

/**
 *
 * Replace a single RestaurantBranchEntity
 */
export const putRestaurantBranchesId = (
  id: string,
  requestBody: RestaurantBranchUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> => {
  return Http.putRequest(
    template(putRestaurantBranchesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putRestaurantBranchesId.key = '/api/v1/restaurant-branches/{id}';

/**
 *
 * Replace a single RestaurantTableEntity
 */
export const putRestaurantTablesId = (
  id: string,
  requestBody: RestaurantTableUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> => {
  return Http.putRequest(
    template(putRestaurantTablesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putRestaurantTablesId.key = '/api/v1/restaurant-tables/{id}';

/**
 *
 * Replace a single RestaurantEntity
 */
export const putRestaurantsId = (
  id: string,
  requestBody: RestaurantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> => {
  return Http.putRequest(
    template(putRestaurantsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putRestaurantsId.key = '/api/v1/restaurants/{id}';

/**
 *
 * Replace a single TransactionCategoryEntity
 */
export const putTransactionCategoriesId = (
  id: string,
  requestBody: TransactionCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> => {
  return Http.putRequest(
    template(putTransactionCategoriesId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putTransactionCategoriesId.key = '/api/v1/transaction-categories/{id}';

/**
 *
 * Replace a single TransactionEntity
 */
export const putTransactionsId = (
  id: string,
  requestBody: TransactionUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> => {
  return Http.putRequest(
    template(putTransactionsId.key, { id }),
    undefined,
    requestBody,
    _CONSTANT1,
    overrideConfig(_CONSTANT0, configOverride)
  );
};

/** Key is end point string without base url */
putTransactionsId.key = '/api/v1/transactions/{id}';
export const _CONSTANT0 = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};
export const _CONSTANT1 = [{ bearer: [] }];
export const _CONSTANT2 = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
